import { useEffect, useState } from "react";
import { formatDate } from "../../../../../api/DateUtils";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Column } from "react-table";
import EpaCard from "../../../../../leap-components/EpaCard";
import BreadCrumbs from "./../BreadCrumbs";
import Header from "./../Header";
import { Grid } from "../../../../../leap-components/Grid";
import { SelectColumnFilter } from "../../../../../leap-components/Grid/NoFetchGrid/SelectColumnFilter";
import CircularEconomyHomeContainer from "./../CircularEconomyHomeContainer";
import {
  GetFilteredNotifiersFetchUrl,
  GetFilteredNotifiersCsv,
} from "../../../../../api/CircularEconomy/INotifiers";
import { EpaGridOrderByFetchParams } from "../../../../../leap-components/Grid/EpaGridProps";
import { CreateStaticSelectColumnFilter } from "../../../../../leap-components/Grid/FetchGrid/StaticSelectColumnFilter";

interface ISearchResultRow {
  licence_name: string;
  licence_number: string;
  organisation: string;
  town: string;
  county: string;
}

const countyFilterValues = [
  { value: "Antrim", label: "Antrim" },
  { value: "Armagh", label: "Armagh" },
  { value: "Carlow", label: "Carlow" },
  { value: "Cavan", label: "Cavan" },
  { value: "Clare", label: "Clare" },
  { value: "Cork", label: "Cork" },
  { value: "Derry", label: "Derry" },
  { value: "Donegal", label: "Donegal" },
  { value: "Down", label: "Down" },
  { value: "Dublin", label: "Dublin" },
  { value: "Fermanagh", label: "Fermanagh" },
  { value: "Galway", label: "Galway" },
  { value: "Kerry", label: "Kerry" },
  { value: "Kildare", label: "Kildare" },
  { value: "Kilkenny", label: "Kilkenny" },
  { value: "Laois", label: "Laois" },
  { value: "Leitrim", label: "Leitrim" },
  { value: "Limerick", label: "Limerick" },
  { value: "Longford", label: "Longford" },
  { value: "Louth", label: "Louth" },
  { value: "Mayo", label: "Mayo" },
  { value: "Meath", label: "Meath" },
  { value: "Monaghan", label: "Monaghan" },
  { value: "Offaly", label: "Offaly" },
  { value: "Roscommon", label: "Roscommon" },
  { value: "Sligo", label: "Sligo" },
  { value: "Tipperary", label: "Tipperary" },
  { value: "Tyrone", label: "Tyrone" },
  { value: "Waterford", label: "Waterford" },
  { value: "Westmeath", label: "Westmeath" },
  { value: "Wexford", label: "Wexford" },
  { value: "Wicklow", label: "Wicklow" },
];

const typeFilterValues = [
  { value: "EU Registration", label: "EU Registration" },
  { value: "National Registration", label: "National Registration" },
  { value: "Single Case Notification", label: "Single Case Notification" },
  { value: "Single Case Registration", label: "Single Case Registration" },
];

const statusFilterValues = [
  { value: "Applied", label: "Applied" },
  { value: "Deregistered", label: "Deregistered" },
  { value: "Determined as By Product", label: "Determined as By Product" },
  { value: "Determined as Waste", label: "Determined as Waste" },
  { value: "Noted", label: "Noted" },
  { value: "Notified", label: "Notified" },
  { value: "Registered", label: "Registered" },
  { value: "Withdrawn", label: "Withdrawn" },
];

const GetUrlForNotifier = (NotifierId: string) => {
  return `/notifier/${NotifierId}`;
};

const CircularEconomyHome = () => {
  const [searchValue, setSearchValue] = useState("");

  const searchChangedFn = (newSearch: string) => {
    setSearchValue(newSearch);
  };

  const tableColumnsBig: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Reg Number",
      accessor: "reg_no",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return (
          <Link to={GetUrlForNotifier(rowData.notifier_id)}>
            {rowInfo.value}
          </Link>
        );
      },
      sortType: "basic",
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: CreateStaticSelectColumnFilter(
        typeFilterValues.map((n) => n.value)
      ),
      filter: "includes",
    },
    {
      Header: "Date Received",
      accessor: "date_received",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Date Closed",
      accessor: "date_closed",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Notified Material",
      accessor: "notified_material",
      Filter: false,
    },
    {
      Header: "Notifier Name",
      accessor: "notifier_name",
      Filter: false,
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: CreateStaticSelectColumnFilter(
        statusFilterValues.map((n) => n.value)
      ),
      filter: "includes",
    },
    {
      Header: "Local Authority at Source",
      accessor: "source_local_authority",
      Filter: false,
    },
    {
      Header: "Source County",
      accessor: "source_county",
      Filter: CreateStaticSelectColumnFilter(
        countyFilterValues.map((n) => n.value)
      ),
      filter: "includes",
    },
    {
      Header: "Local Authority at Use",
      accessor: "use_local_authority",
      Filter: false,
    },
    {
      Header: "Use County",
      accessor: "use_county",
      Filter: CreateStaticSelectColumnFilter(
        countyFilterValues.map((n) => n.value)
      ),
      filter: "includes",
    },
    {
      Header: "Open for submission",
      accessor: "open_for_submissions",
      Filter: false,
      Cell: (rowInfo: any) => (rowInfo.value == 1 ? "Yes" : "No"),
    },
  ];

  const tableColumnsSmall: Column<Record<string, ISearchResultRow>>[] = [
    {
      Header: "Reg Number",
      accessor: "reg_no",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return (
          <Link to={GetUrlForNotifier(rowData.notifier_id)}>
            {rowInfo.value}
          </Link>
        );
      },
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Date Received",
      accessor: "date_received",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Notified Material",
      accessor: "notified_material",
      Filter: false,
    },
    {
      Header: "Notifier Name",
      accessor: "notifier_name",
      Filter: false,
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
    {
      Header: "Open for submission",
      accessor: "open_for_submissions",
      Filter: false,
      Cell: (rowInfo: any) => (rowInfo.value == 1 ? "Yes" : "No"),
    },
  ];

  const getFetchUrlFactory = () => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any,
      orderBy?: EpaGridOrderByFetchParams
    ) => {
      return GetFilteredNotifiersFetchUrl(
        pageNo,
        recordsPerPage,
        searchText,
        filters,
        orderBy
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory();

  const orderBy = {
    orderByAscending: false,
    orderByName: "Reg Number",
    enabledOrderByColumns: ["Reg Number", "Date Received", "Date Closed"],
  };

  const results = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
          orderBy={orderBy}
          exportToCsvFunction={GetFilteredNotifiersCsv}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
          orderBy={orderBy}
          exportToCsvFunction={GetFilteredNotifiersCsv}
        />
      </div>
    </div>
  );

  const contentElement = (
    <div>
      <Row>
        <Col className="ps-0">
          <EpaCard title="Search By-Product Registers" content={results} />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs />
      <div className="ps-0">
        <Header />
        <CircularEconomyHomeContainer content={contentElement} />
      </div>
    </div>
  );
};

export default CircularEconomyHome;
